import { ReactComponent as SmsIcon } from './svg/sms.svg'

export default SmsIcon
